import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import EventType from '../../common/event-type';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { IconButton, Grid, Box } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import getStatusByLang from '../../common/statusByLang';
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import downloadpdf from '../images/download-pdf.png';

const localeTheme = createTheme(
    {

    },
    localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);
function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    if (array && array.length <= 0) {
        return [];
    }
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
    createSortHandler = (property, field) => event => {
        this.props.onRequestSort(event, property, field);
    };

    render() {
        const {
            order,
            orderBy,
            sortId,
            t
        } = this.props;
        const rows = [
            { id: "rxno", numeric: false, disablePadding: false, label: t("Report.Transaction.RxHash"), padding: '10px', field: 'rx_no' },
            { id: "fillid", numeric: false, disablePadding: false, label: t("Report.Transaction.FillID"), padding: '10px', field: 'fill_id' },
            { id: "type", numeric: false, disablePadding: false, label: t("Report.Transaction.TransactionType"), padding: '10px', field: 'name' },
            { id: "transactiondate", numeric: false, disablePadding: false, label: t("Report.Transaction.TransactionDate"), padding: '10px', field: 'created_on' },
            { id: "username", numeric: false, disablePadding: false, label: t("Report.Transaction.User"), padding: '10px', field: 'username' },
        ];

        return (
            <TableHead>
                <TableRow>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
                            >
                                {[
                                    "deliverytype",
                                    "fillid",
                                    "prescriptionnumber",
                                    "OrderId",
                                    "PrescriptionTxnId",
                                    "ndccode",
                                    "qty",
                                    "price",
                                    "previousprice",
                                    "createdon",
                                    "type",
                                ].includes(row.id) ? (
                                    <TableSortLabel style={{ cursor: "text" }}>{row.label}</TableSortLabel>
                                ) : (
                                    <Tooltip
                                        title={t("Global.Label.Filter.Sort")}
                                        placement={row.numeric ? "bottom-end" : "bottom-start"}
                                        enterDelay={300}
                                    >
                                        <TableSortLabel
                                            active={orderBy === row.field && sortId === row.id}
                                            direction={order}
                                            onClick={this.createSortHandler(row.id, row.field)}
                                        >
                                            {row.label}
                                        </TableSortLabel>
                                    </Tooltip>
                                )}
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead)

const styles = theme => ({
    table: {
        minWidth: 1020
    },
    tableWrapper: {
        overflowX: "auto"
    },
    dob: {
        paddingTop: '25px',
    },
    headerdiv: {
        paddingLeft: '15%',
        paddingTop: '10'
    }
    ,
    padding10px: {
        padding: '8px'
    }
    , formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 390,
    },
    logoWrapper:
    {
        position: 'absolute',
        width: '89%',
        height: '70%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.5)',
        zIndex: '7869'
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
    hidden: {
        display: 'none'
    }

});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
let TransactionFilterObj = {
    store_ids: [],
    box_ids: [],
    searchtext: '',
    fromdate: '',
    todate: '',
    pageNo: 0,
    pageSize: 10,
    sortOrder: 'desc',
    sortColumn: 'created_on',
    tableName: '',
    group_id: null
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            order: "desc",
            dob: '',
            orderBy: "created_on",
            page: 0,
            rowsPerPage: 10,
            searchtext: '',
            store_id: [],
            box_id: [],
            fromdate: null,
            todate: null,
            isOpen: false,
            stores: [],
            boxes: [],
            boxvalues: [],
            accountValues: [],
            nstores: [],
            nboxes: [],
            chipstores: [],
            chipboxes: [],
            loader: false,
            isDataEmpty: true,
            totalRecords: 0,
            isButtonDisabled: false,
            locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
            queryId: "",
            groups: [],
        };
        this.handleStoreChange = this.handleStoreChange.bind(this);
        this.handleBoxChange = this.handleBoxChange.bind(this);
        this.debouceTimeout = null;
    }

    componentDidMount() {
        TransactionFilterObj.group_id = sessionStorage.getItem("groupID")
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + "accounts", {
            method: 'GET',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(accounts => {
                const { t } = this.props;
                let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
                const storelist = accounts.map(account => {
                    return { id: account.id, name: account.name };

                });
                const accountValues = All.concat(storelist);
                this.setState({ accountValues, parent_account_id: accountValues[0].id });
                this.BindBoxesbyStoreId(storelist.map(x => x.id));
                this.setState({ loader: false });
            });
        this.fetchSuggestions()
        this.BindGrid();
    }

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        let zone;
        zone = sessionStorage.getItem('timeZone');
        const date = moment(new Date(requestDate));
        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }
        return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
    }
    exportCSV() {
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + 'CSV/CycleReviewReport', {
            method: 'POST',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(TransactionFilterObj)
        })
            .then(response => {
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            })
            .then((csvData) => {
                this.setState({ loader: false });
                let csvRow = [];
                let Array = [['StoreID', 'Rx No', 'Fill ID', 'Status', 'Transaction Date', 'User']];
                let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
                if (result !== undefined && result !== 'undefined') {
                    if (result && result.length > 0) {
                        for (let i of result) {
                            Array.push(
                                [
                                    i.rxno,
                                    i.fillid,
                                    i.status,
                                    i.transactiondate ? this.convertToTimeZone(i && i.transactiondate) : '',
                                    i.username
                                ]
                            );
                        }
                        for (let i of Array) {
                            csvRow.push(i.join(","));
                        }
                        let csvString = csvRow.join("%0A");
                        let element = document.createElement("a");
                        element.href = 'data:attachment/csv.' + csvString;
                        element.target = "_Blank";
                        element.download = "TransactionReport.csv";
                        document.body.appendChild(element);
                        element.click();
                    }
                }
            });
    };

    gettingOnSortTableName = (field) => {
        let tablename = '';
        if (['rxno',].includes(field)) {
            tablename = 'prescription_detail';
        }
        if (['transactiondate'].includes(field)) {
            tablename = 'events';
        }
        if (['username'].includes(field)) {
            tablename = 'users';
        }
        if (['status'].includes(field)) {
            tablename = 'event_type';
        }
        return tablename;
    }

    handleRequestSort = (event, property, field) => {
        const orderBy = property;
        let order = "desc";
        if (this.state.orderBy === orderBy) {
            order = this.state.order === "asc" ? "desc" : "asc";
        } else if (this.state.order === order) {
            order = "asc";
        } else {
            order = "desc";
        }
        this.setState({ order, orderBy, sortId: property });
        TransactionFilterObj.sortOrder = order;
        TransactionFilterObj.sortColumn = field;
        TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
        const { data } = this.state;
        if (data && data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangePage = (event, page) => {
        event && event.preventDefault();
        const { data } = this.state;
        TransactionFilterObj.pageNo = page;
        if (data && data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangeRowsPerPage = event => {
        const { data } = this.state;
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.pageSize = event.target.value;
        if (data && data.length > 0) {
            this.BindGrid();
        }
    };

    //Bind Boxes by store id
    BindBoxesbyStoreId(store_ids) {
        if (store_ids.length > 0) {
            this.setState({ loader: true });
            let BoxesObj = {
                store_ids: store_ids
            }
            fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
                method: 'post',
                withCredentials: true,
                headers: {
                    'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(BoxesObj)
            })
                .then(response => {
                    try {
                        return response.json();
                    } catch (error) {
                        return null;
                    }
                })
                .then(data => {
                    const { t } = this.props;
                    let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
                    const boxlist = data.map(account => {
                        return { id: account.id, name: account.name };
                    });
                    const boxvalues = All.concat(boxlist);
                    //const boxvalues = boxlist;
                    this.setState({ chipboxes: [] });
                    this.setState({ nboxes: [] });
                    this.setState({ boxvalues: boxvalues });
                    // this.setState({chipboxes:[]});
                    this.setState({ loader: false });
                });
        }

    }
    handleStoreChange = event => {
        const storeid = event.target.value;
        const storeids = [];
        let processed = [];
        let chipprocessed = [];
        const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
        if (event.target.value.length === 1 && AllprocessedIndex > -1) {
            const element = event.target.value[AllprocessedIndex];
            chipprocessed.push(element);
            for (let i = 0; i < this.state.accountValues.length; i++) {
                processed.push(this.state.accountValues[i]);
            }
        }
        else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
            for (let i = 0; i < this.state.accountValues.length; i++) {
                const element = storeid.findIndex(x => x.id === this.state.accountValues[i].id);
                if (element > -1) {
                }
                else {
                    chipprocessed.push(this.state.accountValues[i]);
                    processed.push(this.state.accountValues[i]);
                }
            }
        }
        else if (storeid.length === 0 && AllprocessedIndex === -1) {
            chipprocessed = [];
            processed = [];
        }
        else if (storeid.length > 0) {
            for (let i = 0; i < event.target.value.length; i++) {
                const element = event.target.value[i];
                if (element.id !== '-1') {
                    chipprocessed.push(element);
                    processed.push(element);
                }
                else {

                }
            }
        }
        this.setState({ chipstores: chipprocessed });
        this.setState({ nstores: processed });

        if (processed.length > 0) {
            for (let i = 0; i < processed.length; i++) {
                if (processed[i].id !== '-1') {
                    storeids.push(processed[i].id)
                }
            }
        }
        this.setState({ store_id: storeids });
        TransactionFilterObj.store_ids = storeids;
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        this.BindBoxesbyStoreId(storeids);
        this.BindGrid();
    };
    handleBoxChange = event => {
        const boxid = event.target.value;
        const boxids = [];

        let processed = [];
        let chipprocessed = [];
        const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
        if (event.target.value.length === 1 && AllprocessedIndex > -1) {
            const element = event.target.value[AllprocessedIndex];
            chipprocessed.push(element);
            for (let i = 0; i < this.state.boxvalues.length; i++) {
                processed.push(this.state.boxvalues[i]);
            }
        }
        else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
            for (let i = 0; i < this.state.boxvalues.length; i++) {
                const element = boxid.findIndex(x => x.id === this.state.boxvalues[i].id);
                if (element > -1) {
                }
                else {
                    chipprocessed.push(this.state.boxvalues[i]);
                    processed.push(this.state.boxvalues[i]);
                }
            }
        }
        else if (boxid.length === 0 && AllprocessedIndex === -1) {
            chipprocessed = [];
            processed = [];
        }
        else if (boxid.length > 0) {
            for (let i = 0; i < event.target.value.length; i++) {
                const element = event.target.value[i];
                if (element.id !== '-1') {
                    chipprocessed.push(element);
                    processed.push(element);
                }
                else {

                }
            }
        }
        this.setState({ chipboxes: chipprocessed });
        this.setState({ nboxes: processed });

        if (processed.length > 0) {
            for (let i = 0; i < processed.length; i++) {
                if (processed[i].id !== '-1') {
                    boxids.push(processed[i].id)
                }
            }
        }
        this.setState({ box_id: boxids });
        TransactionFilterObj.box_ids = boxids;
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        this.BindGrid();
    };

    onFromDateSelect = date => {
        date = date ? moment(date).format() : '';
        this.setState({ fromdate: date });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        TransactionFilterObj.fromdate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    };
    onToDateSelect = date => {
        date = date ? moment(date).format() : '';
        this.setState({ todate: date });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        TransactionFilterObj.todate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ loader: true })
        this.BindGrid();
    };
    handleBlurfrom = (value, date) => {
        this.setState({
            fromdate: null
        });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        TransactionFilterObj.fromdate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    }
    handleBlurtodate = (value, date) => {
        this.setState({
            todate: null
        });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        TransactionFilterObj.todate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    }

    BindGrid = () => {
        this.setState({ loader: true, data: null });
        fetch(process.env.REACT_APP_BASEURL + 'getCycleReview', {
            method: 'post',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(TransactionFilterObj)
        })
            .then(response => {
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            })
            .then(uData => {
                if (uData && uData.results && uData.results.length > 0) {
                    this.setState({ data: uData.results, totalRecords: uData && uData.total });
                    setTimeout(() => {
                        this.setState({ loader: uData && uData.total && false, isDataEmpty: false, isButtonDisabled: false })
                    }, 5000)
                }
                else {
                    this.setState({ data: null, loader: false, isDataEmpty: true, isButtonDisabled: true });
                }
            });
    };

    getDatebyStatus(date, status, value, zone) {
        let newdate = '';
        if (date !== null && status === 'ASSIGNED' && EventType.ASSIGNED === value) {
            newdate = date !== "" ? this.convertToTimeZone(date) : ''
        }
        else if (date !== null && status === 'STOCKED' && EventType.STOCKED === value) {
            newdate = date !== "" ? this.convertToTimeZone(date) : ''
        }
        else if (date !== null && status === 'PICKED_UP' && EventType.PICKED_UP === value) (
            newdate = date !== "" ? this.convertToTimeZone(date) : ''
        )
        return newdate;
    }

    getCustomStatus = (status, t, n) => {
        if (status === "VERFIY RX") {
            if ([true, 'true'].includes(n.is_mis_matached)) {
                return t("Global.Prescriptions.Status.MisMatched")
            } else {
                return getStatusByLang("VERIFIED", t)
            }
        } else if (status === "RX EXPIRED") {
            return getStatusByLang("EXPIRED", t)
        } else if (status === "REMOVE RX") {
            return getStatusByLang("REMOVED", t)
        } else if (status === "RX HOLD") {
            return getStatusByLang("ON HOLD", t)
        } else {
            return getStatusByLang(status, t);
        }
    }

    exportPDF = () => {
        try {
            this.setState({ loader: true });
            fetch(process.env.REACT_APP_BASEURL + 'printCycleReview', {
                method: 'post',
                withCredentials: true,
                headers: {
                    Authorization:
                        'Bearer ' +
                        JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                            .jwtToken,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(TransactionFilterObj),
            })
                .then((response) => {
                    try {
                        return response.text();
                    } catch (error) {
                        return null;
                    }
                })
                .then((res) => {
                    this.setState({ loader: false });
                    var x = window.open(
                        '',
                        'title',
                        'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=1000,left=145,top=100'
                    );
                    x.document.write(res);
                    x.document.close();
                    setTimeout(() => {
                        x.print();
                        x.close();
                    }, 5000);
                })
                .catch((error) => {
                    this.setState({ loader: false });
                });
        } catch (error) {
            this.setState({ loader: false });
        }
    };

    handleInputChange = (event) => {
        this.setState({ queryId: event.target.value });
        TransactionFilterObj.group_id = event.target.value
        this.BindGrid();
    };

    fetchSuggestions = async () => {
        try {
            const result = fetch(`${process.env.REACT_APP_BASEURL}groups`, {
                method: "GET",
                withCredentials: true,
                headers: {
                    Authorization:
                        "Bearer " +
                        JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                            .jwtToken,
                    "Content-Type": "application/json",
                },
            }
            );
            result
                .then((result) => {
                    result.json().then((resLocation) => {
                        this.setState({ groups: resLocation && resLocation.data })
                    })
                })
        } catch (error) {
            console.error("Error fetching groups:", error);
        }
    };

    render() {
        const { classes, t } = this.props;
        const { data, totalRecords, locale, queryId, groups } = this.state;
        return (
            <div>
                {
                    this.state.loader ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> :
                        null
                }

                <Box component="div">
                    <Grid container spacing={4} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
                        <Grid item xs={3} md={3} style={{ paddingLeft: 0 }}>
                            <FormControl sx={{ width: '100%' }}>
                                <InputLabel sx={{ ml: '-4%' }} htmlFor="select-multiple-chip-store">{t("Report.Transaction.StoreDropdown")}</InputLabel>
                                <Select
                                    multiple
                                    value={this.state.chipstores}
                                    onChange={this.handleStoreChange}
                                    input={<Input id="select-multiple-chip-store" />}
                                    renderValue={selected => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map(value => (
                                                <Chip key={value.name} label={value.name} />
                                            ))}
                                        </Box>
                                    )}
                                    MenuProps={MenuProps}
                                >
                                    {this.state.accountValues !== undefined && this.state.accountValues.map(item => (
                                        <MenuItem key={item.id} value={item}>
                                            <Checkbox checked={this.state.nstores.map(x => x.id).indexOf(item.id) > -1} />
                                            <ListItemText primary={item.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3}>
                            <FormControl sx={{ width: '100%' }}>
                                <InputLabel sx={{ ml: '-4%' }} htmlFor="select-multiple-chip">{t("Report.Transaction.Box")}</InputLabel>
                                <Select
                                    multiple
                                    value={this.state.chipboxes}
                                    onChange={this.handleBoxChange}
                                    input={<Input id="select-multiple-chip" />}
                                    renderValue={selected => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map(value => (
                                                <Chip key={value.id} label={value.name} className={classes.chip} />
                                            ))}
                                        </Box>
                                    )}
                                    MenuProps={MenuProps}
                                >
                                    {this.state.boxvalues !== undefined && this.state.boxvalues.map(item => (
                                        <MenuItem key={item.id} value={item}>
                                            <Checkbox checked={this.state.nboxes.map(x => x.id).indexOf(item.id) > -1} />
                                            <ListItemText primary={item.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3}>
                            <FormControl sx={{ width: '100%' }}>
                                <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                    <DesktopDatePicker
                                        disableFuture
                                        keyboard
                                        value={this.state.fromdate}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label={t("Report.Transaction.FromDate")}
                                                variant="standard"
                                                allowKeyboardControl={true}
                                                onBlur={this.handleBlurfrom}
                                            />
                                        }
                                        onChange={this.onFromDateSelect}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3}>
                            <FormControl sx={{ width: '100%' }}>
                                <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                    <DesktopDatePicker
                                        disableFuture
                                        keyboard
                                        value={this.state.todate}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label={t("Report.Transaction.ToDate")}
                                                variant="standard"
                                                allowKeyboardControl={true}
                                                onBlur={this.handleBlurtodate}
                                            />
                                        }
                                        onChange={this.onToDateSelect}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-between'} spacing={0} sx={{ mt: '1rem', ml: 0, width: '100%', p: '0% 2% 1%' }}>
                        <Grid item xs={3} md={3}>
                            <FormControl
                                variant='standard'
                                sx={{ m: '0', minWidth: 347 }}
                            >
                                <InputLabel id='preferred-group-label'>
                                    {t('Group.User.GroupControlTitle')}
                                </InputLabel>
                                <Select
                                    labelId='preferred-group-label'
                                    id='preferred-group-select-standard'
                                    value={queryId}
                                    onChange={this.handleInputChange}
                                    variant='standard'
                                    label={t('Group.User.GroupControlTitle')}
                                >
                                    {groups.length > 0 &&
                                        groups.map((type, index) => (
                                            <MenuItem
                                                key={index}
                                                value={type.id}
                                                className={classes.locationType}
                                            >
                                                {type.name}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3}>
                            <FormControl fullWidth>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3}>
                            <FormControl fullWidth>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
                            <Tooltip key="single-edit" title="ExportCSV">
                                <IconButton
                                    style={{ marginRight: '0' }}
                                    aria-label={t("Report.Transaction.ExportCSVTooltip")}
                                    onClick={() => { this.exportCSV() }}
                                    disabled={this.state.isButtonDisabled}
                                >
                                    <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip
                                key='single-edit'
                                title={t('Report.Stocked.ExportPDFTooltip')}
                            >
                                <IconButton
                                    aria-label='ExportPDF'
                                    onClick={() => {
                                        this.exportPDF();
                                    }}
                                    disabled={this.state.isButtonDisabled}
                                >
                                    <img
                                        alt='download'
                                        src={downloadpdf}
                                        style={{
                                            height: '32px',
                                            width: '32px',
                                            cursor: 'pointer',
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Box>

                <Divider style={{ marginTop: '10px', height: '5px' }} />
                <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle">
                        <EnhancedTableHead
                            order={TransactionFilterObj.sortOrder}
                            orderBy={TransactionFilterObj.sortColumn}
                            sortId={this.state.sortId}
                            onRequestSort={this.handleRequestSort}
                        />
                        <TableBody>
                            {!data ?
                                (<TableRow>
                                    <TableCell colSpan={25} style={{ textAlign: "center", padding: '10px 0px' }}>
                                        {this.state.isDataEmpty && t("Report.Transaction.NoDataFound")}
                                    </TableCell>
                                </TableRow>)
                                : data.length && data.length > 0 &&
                                stableSort(data, getSorting(TransactionFilterObj.sortOrder, TransactionFilterObj.sortColumn))
                                    .map(n => {
                                        return (
                                            <TableRow>
                                                <TableCell className={classes.padding10px} >{n.rxno}</TableCell>
                                                <TableCell className={classes.padding10px} >{n.fillid}</TableCell>
                                                <TableCell className={classes.padding10px} >{(n.status !== null && n.status !== "") ? this.getCustomStatus(n.status.replaceAll("_", " "), t, n) : ''}</TableCell>
                                                <TableCell className={classes.padding10px} >{n.transactiondate ? this.convertToTimeZone(n && n.transactiondate) : ''}</TableCell>
                                                <TableCell className={classes.padding10px} >{n.username}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                        </TableBody>
                    </Table>
                </div>
                <ThemeProvider theme={localeTheme}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalRecords || 0}
                        rowsPerPage={TransactionFilterObj.pageSize}
                        page={TransactionFilterObj.pageNo}
                        backIconButtonProps={{
                            "aria-label": "Previous Page"
                        }}
                        nextIconButtonProps={{
                            "aria-label": "Next Page"
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/cycle-review/index.js